import * as React from 'react'
import { Grid } from '@material-ui/core'
import {
	Elements,
	Loader
} from '@tfo/common'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import { useIntl } from 'react-intl'
import { MyAccountsInformation } from './components/myaccount-info'
import '../client/Client.scss'
import './myaccount.scss'
import { useStore } from '../../hooks/useStore'
import { LoginMethod } from './components/login-method'


const MyAccount = observer(() => {
	const { clientViewStore } = useStore()
	const intl = useIntl()
	const { Label } = Elements
	const [contentIndex, setContentIndex] = React.useState(0)

	const getContent = () => {

		switch (contentIndex) {
			case 0:
				return (
					<Grid item>
						<MyAccountsInformation />
					</Grid>
				)
			case 1:
				return (
					<>
						<LoginMethod />
					</>
				)
			default:
				return <></>
		}
	}

	return (
		<>
			<Grid
				container
				justifyContent="center"
				direction="column"
				className="GridWrapper"
				style={{ marginTop: '2rem', marginBottom: '2rem' }}>
				<Grid item container direction="row" xs={12}>
					<Grid item xs={6} style={{ padding: '1em' }}>
						<h1 className="Heading1">
							{intl.formatMessage({ id: 'common.myAccount' })}
						</h1>
					</Grid>
					<Grid item>
						<div className="ReportsFiltering ReportsFilteringMenu">
							<Label
								className={classnames('ReportsFiltering__Item', {
									'ReportsFiltering__Item--active': contentIndex === 0,
								})}
								onClick={() => setContentIndex(0)}>
								{intl.formatMessage({ id: 'common.user.information' })}
							</Label>
							<Label
								className={classnames('ReportsFiltering__Item', {
									'ReportsFiltering__Item--active': contentIndex === 1,
								})}
								onClick={() => setContentIndex(1)}>
								{intl.formatMessage({ id: 'common.loginMethod' })}
							</Label>
						</div>
					</Grid>
				</Grid>
				{getContent()}
				{clientViewStore.loading && <Loader />}
			</Grid>
		</>
	)
})
export default MyAccount
